import fr from 'facet-rest';
import Autocomplete from 'Components/UI/Autocomplete';

const calendarEventFieldsToHide = [
  'createdAt',
  'updatedAt',
  'householdId',
  'eventId',
  'startTime',
  'endTime',
  'location',
  'meetingType',
  'eventType',
  'subject',
  'lastName',
  'priority',
  'bestNextStepId',
  'content',
  'bufferLength',
  'isCancelled',
  'title',
  'description',
  'source',
];

// eslint-disable-next-line import/prefer-default-export
export const ClientSchedulerRescheduleCalendarEvent = fr.metaOverride()
  .nameOverride(calendarEventFieldsToHide, { hidden: true })
  .nameOverride('attendees', { _component: () => Autocomplete });
